// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { api } from "../lib/api";

export default function AuthCallback() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { window.location.href = "/"; return; }
    const sessionId = m[1];
    (async () => {
      try {
        await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState({}, "", "/admin");
        window.location.href = "/admin";
      } catch (e) {
        window.location.href = "/";
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#D4AF37]">
      <div className="text-center">
        <div className="font-serif-lux text-3xl mb-2">Authenticating</div>
        <div className="text-sm text-neutral-400">Just a moment...</div>
      </div>
    </div>
  );
}
